// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2Y4Ka","ranges":"BmiRanges_ranges__h7CnE"};